/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Hub_About_Uses_EverythingInputs */



/**
* | output |
* | --- |
* | "Everything you can access" |
*
* @param {Agent_Hub_About_Uses_EverythingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_hub_about_uses_everything = /** @type {((inputs?: Agent_Hub_About_Uses_EverythingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Hub_About_Uses_EverythingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alles, worauf Sie Zugriff haben")
	return /** @type {LocalizedString} */ ("Everything you can access")
});